import { defineComponent as _defineComponent } from 'vue'
import {computed, watch} from 'vue';
import InterestRateRow from '@/components/calculator/schedule/schedule-table/InterestRateRow.vue';
import {Offer} from '@/models/simulation/Simulation';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {ScheduleVariant} from '@/components/calculator/schedule/models/ScheduleVariant';
import ScheduleTableRow from '@/components/calculator/schedule/schedule-table/ScheduleTableRow.vue';
import ShowMoreRow from '@/components/calculator/schedule/schedule-table/ShowMoreRow.vue';
import {ScheduleRow, ScheduleRowWithVisible} from '@/components/calculator/schedule/Schedule';
import {isEmpty, sum} from 'lodash-es';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleTable',
  props: {
    offer: null,
    loading: { type: Boolean, default: false },
    print: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { offer: Offer, loading: boolean, print: boolean }



const store = useScheduleStore();

const headers = computed<ScheduleTableHeaders>(() => {
  const commonHeaders = {
    yearAndMonth: `${I18NGetter().useScheduleTable.YEAR} / ${I18NGetter().useScheduleTable.MONTH}`,
    monthlyFee: I18NGetter().useScheduleTable.FULL_INSTALLMENT,
    interestFee: I18NGetter().useScheduleTable.INTEREST_INSTALLMENT,
    capitalFee: I18NGetter().useScheduleTable.CAPITAL_INSTALLMENT,
  };

  const homeStartProgramheaders = {
    interestSubsidys: 'Dopłata',
  }

  const showAdditionalCostsHeaders = {
    additionalCosts: I18NGetter().useScheduleTable.ADDITIONAL_COSTS,
    monthlyCost: I18NGetter().useScheduleTable.MONTHLY_COST,
  };

  const capitalPaidAndActualCapitalHeaders = {
    capitalPaid: I18NGetter().useScheduleTable.CAPITAL_REPAID,
    actualCapital: I18NGetter().useScheduleTable.CAPITAL_TO_BE_REPAID,
  };

  if (store.isHomeStartProgram && store.showAdditionalCosts) {
    return {
      ...commonHeaders,
      ...showAdditionalCostsHeaders,
      ...homeStartProgramheaders,
      ...capitalPaidAndActualCapitalHeaders,
    }
  } else if (store.showAdditionalCosts) {
    return {
      ...commonHeaders,
      ...showAdditionalCostsHeaders,
      ...capitalPaidAndActualCapitalHeaders,
    };
  } else if (store.isHomeStartProgram) {
    return {
      ...commonHeaders,
      ...homeStartProgramheaders,
      ...capitalPaidAndActualCapitalHeaders,
    }
  } else {
    return {
      ...commonHeaders,
      ...capitalPaidAndActualCapitalHeaders,
    };
  }
});

const calculateFeeSum = (value: number): number => {
  return value - store.earlyPaymentSum;
};

const monthlyFeeSum = computed<number>(() => {
  const sum: number = (store.schedule?.totalInterestFee || props.offer.totals.costsSum) + props.offer.totals.capital;
  return calculateFeeSum(sum);
});

const additionalCostsSum = computed<number>(() => {
  return sum(store.scheduleRows.map(row =>
    sum(row.additionalCosts?.map(cost => cost.fee)) || 0
  ));
});

const monthlyCostSum = computed<number>(() => {
  return monthlyFeeSum.value + additionalCostsSum.value;
});

const interestSubsidys = computed<number>(() => {
  return sum(store.scheduleRows.map(row => row.interestSubsidy)) || 0;
})

const capitalFeeSum = computed<number>(() => {
  const capitalSum: number = props.offer.totals.capital;
  return calculateFeeSum(capitalSum);
});

const tableItems = computed<ScheduleRowWithVisible[]>(() => {
  return store.scheduleRows.filter((row: Required<ScheduleRowWithVisible>) => !store.showAdditionalCosts ? row.currentMonth : true);
});

const isInterestRateRowVisible = (row: Required<ScheduleRow>): boolean => Boolean(row.currentMonth === 1 ||
  (props.offer.changingMargin && props.offer.changingMargin.initialPeriod! + 1 === row.currentMonth));

const isShowMoreRowVisible = (row: Required<ScheduleRowWithVisible>): boolean => {
  const previousRowIndex: number = Math.max(row.currentMonth - 1, 0);
  const previousRow: Required<ScheduleRowWithVisible> =
    store.scheduleRows[previousRowIndex] as Required<ScheduleRowWithVisible>;
  return previousRow.visible && !row.visible;
};

return { __sfc: true,props, store, headers, calculateFeeSum, monthlyFeeSum, additionalCostsSum, monthlyCostSum, interestSubsidys, capitalFeeSum, tableItems, isInterestRateRowVisible, isShowMoreRowVisible, InterestRateRow, I18NGetter, ScheduleTableRow, ShowMoreRow }
}

})